import { render } from "./DocumentUsersList.vue?vue&type=template&id=be42a1ce&scoped=true"
import script from "./DocumentUsersList.vue?vue&type=script&lang=js"
export * from "./DocumentUsersList.vue?vue&type=script&lang=js"

import "./DocumentUsersList.vue?vue&type=style&index=0&id=be42a1ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be42a1ce"]])

export default __exports__